import React, { useEffect, useState } from "react";
import { Typography, Box, Card, Grid } from "@mui/joy";
import { LoadingView, PageTitle } from "../../../components";
import { fetchDashboardRequest } from "../../../store/actions";
import { CardContent } from "@mui/material";
import {
  Folder,
  GroupOutlined,
  PaidOutlined,
  Person,
} from "@mui/icons-material";
import {
  NAVIGATE_TO_ACCOUNTSPAGE,
  NAVIGATE_TO_AGENTSPAGE,
  NAVIGATE_TO_PARTNERSPAGE,
  NAVIGATE_TO_STAFFPAGE,
  NAVIGATE_TO_TRANSACTIONPAGE,
} from "../../../route/types";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { STATUS } from "../../../constant";

const Dashboard = ({ loginResult, dashboardStatus, dashboardResult }) => {
  const dispatch = useDispatch();

  const [partner, setPartner] = useState(0);
  const [agent, setAgent] = useState(0);
  const [agentAccounts, setAgentAccounts] = useState(0);
  const [transactions, setTransactions] = useState(0);

  useEffect(() => {
    if (dashboardStatus === STATUS.SUCCESS) {
      const data = dashboardResult; // ✅ backend wraps in .data
      setPartner(data.partners);
      setAgent(data.agents);
      setAgentAccounts(data.agent_accounts); // ✅ new field
      setTransactions(data.transactions);
    }
  }, [dashboardStatus]);

  useEffect(() => {
    dispatch(fetchDashboardRequest(loginResult.token));
  }, []);

  const cardsItems = [
    loginResult.role !== 3 &&
      loginResult.partner_type === 1 && {
        title: "Total Partners",
        icon: <GroupOutlined sx={{ color: "black", fontSize: "30px" }} />,
        iconBgColor: "greenyellow",
        number: partner,
        action: NAVIGATE_TO_PARTNERSPAGE,
      },
    {
      title: "Total Agents",
      icon: <Person sx={{ color: "white", fontSize: "30px" }} />,
      iconBgColor: "blue",
      number: agent,
      action: NAVIGATE_TO_AGENTSPAGE,
    },
    {
      title: "Agent Accounts",
      icon: <Folder sx={{ color: "white", fontSize: "30px" }} />,
      iconBgColor: "darkorchid",
      number: agentAccounts,
    },
    {
      title: "Transactions",
      icon: <PaidOutlined sx={{ color: "white", fontSize: "30px" }} />,
      iconBgColor: "green",
      number: transactions,
      action: NAVIGATE_TO_TRANSACTIONPAGE,
    },
  ];

  return (
    <Box>
      <PageTitle title="Dashboard" />
      <LoadingView loading={dashboardStatus === STATUS.LOADING} />

      <Grid
        container
        spacing={{ xs: 1, md: 1 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ flexGrow: 1 }}
      >
        {cardsItems.map(
          (item, index) =>
            item && (
              <Grid xs={2} sm={3} md={3} key={index}>
                <Link to={item.action} style={{ textDecoration: "none" }}>
                  <Card
                    sx={{
                      backgroundColor: "background.popup",
                      boxShadow: "sm",
                      p: 0,
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Card
                          variant="soft"
                          sx={{
                            backgroundColor: item.iconBgColor,
                            width: "65px",
                            height: "65px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {item.icon}
                        </Card>
                        <Box>
                          <Typography level="body-sm">{item.title}</Typography>
                          <Typography level="h3">{item.number}</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>
            ),
        )}
      </Grid>
    </Box>
  );
};

const mapStateToProps = ({ auth }) => {
  const { otpResult: loginResult, dashboardStatus, dashboardResult } = auth;
  return { loginResult, dashboardStatus, dashboardResult };
};

export default connect(mapStateToProps, {})(Dashboard);
